const REQUIRED = [
  'VITE_SUPABASE_URL',
  'VITE_SUPABASE_PUBLISHABLE_KEY',
  'VITE_APP_ENV',
  'VITE_APP_URL',
] as const;

type EnvKey = (typeof REQUIRED)[number];

export interface AppEnv {
  supabaseUrl: string;
  supabaseAnonKey: string;
  appEnv: string;
  appUrl: string;
  /** Null until the Drive integration is configured; features degrade politely. */
  driveRootFolderId: string | null;
}

/**
 * Validates the public environment at startup and fails fast with a clear
 * message listing every missing variable. Only VITE_-prefixed public values
 * exist here; server-only secrets never enter the browser bundle.
 */
export function readAppEnv(): AppEnv {
  const missing: EnvKey[] = REQUIRED.filter((key) => {
    const value = import.meta.env[key] as string | undefined;
    return !value || value.trim() === '';
  });
  if (missing.length > 0) {
    throw new Error(
      `Missing required environment variable(s): ${missing.join(', ')}. Copy .env.example to .env.local and fill the values (see docs/supabase-setup.md).`,
    );
  }
  const driveRootFolderId = import.meta.env.VITE_DRIVE_ROOT_FOLDER_ID;
  return {
    supabaseUrl: import.meta.env.VITE_SUPABASE_URL,
    supabaseAnonKey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
    appEnv: import.meta.env.VITE_APP_ENV,
    appUrl: import.meta.env.VITE_APP_URL,
    driveRootFolderId:
      driveRootFolderId && driveRootFolderId.trim() !== '' ? driveRootFolderId : null,
  };
}
